'use strict';

// // AngularJS
//const angular = require('angular');
import "angular";
import "angular-messages";
import "angular-ui-bootstrap";
//import "angular-sanitize";
//import "angular-route";
//import "angular-cookies";
//import "angular-animate";
//import "angular-aria";

//Flow
import {Flow} from "../libs/flowjs";
import "@flowjs/ng-flow/dist/ng-flow-standalone.min.js";

import '../libs/paginate-anything.min.js';

function getJsCookieValue(a) {
	var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}

angular.element(document).ready(function () {
	// Add event listeners for all select2 elements
	angular.element(document).on('select2:open', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl) {
			ngModelCtrl.hasOpened = true; // Track that the dropdown was opened
		}
	});

	angular.element(document).on('select2:close', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl && ngModelCtrl.hasOpened) {
			ngModelCtrl.$setTouched(); // Mark the field as touched
			if (!ngModelCtrl.$modelValue) {
				// If no selection was made, trigger the required error
				ngModelCtrl.$setViewValue(null); // Ensure it triggers validation
			}
		}
	});

	angular.element(document).on('change', 'select.select2', function () {
		const ngModelCtrl = angular.element(this).controller('ngModel');
		if (ngModelCtrl) {
			ngModelCtrl.hasOpened = false; // Reset the opened state on change
		}
	});
});

var EwSiteApp = angular.module('EwSiteApp', ['ngMessages', 'flow', 'ui.bootstrap']);

EwSiteApp.config(['$provide', function ($provide) {
		$provide.decorator('$browser', ['$delegate', function ($delegate) {
				$delegate.onUrlChange = function () {};
				$delegate.url = function () {
					return "";
				};
				return $delegate;
			}]);
	}]);

/**
 * ESOEW4-1539: automatinis vienkartinis uzklausos pakartojimas, kai serveris
 * ja blokavo del pasenusio XSRF tokeno.
 *
 * Saugu kartoti: blokuota uzklausa kontrolerio nepasiekia (secure modulio
 * routeAction daro stopPropagation), todel dublikato sukurti negali.
 * Blokuotas atsakymas visada atiduoda sviezia XSRF cookie reiksme, todel
 * pakartojimas jau turi galiojanti tokena.
 *
 * Kartojama tik viena karta ir tik esant xsrf_error zymei, kad nebutu
 * uzmaskuotos tikros klaidos. Serverio puseje blokavimas ir toliau loginamas.
 */
EwSiteApp.factory('xsrfRetryInterceptor', ['$injector', function ($injector) {
		return {
			response: function (response) {
				var config = response.config;
				if (!config || !response.data || response.data.xsrf_error !== true) {
					return response;
				}
				if (config.xsrfRetried) {
					return response;
				}
				if (typeof secure_xsrf_name === 'undefined') {
					return response;
				}
				config.xsrfRetried = true;
				// istrinam uzsaldyta antraste, kad Angular idetu sviezia reiksme is cookie
				if (config.headers) {
					delete config.headers['X-' + secure_xsrf_name];
				}
				return $injector.get('$http')(config);
			}
		};
	}]);

EwSiteApp.config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('xsrfRetryInterceptor');
	}]);

EwSiteApp.filter('u2date', ['$filter', function ($filter) {
		return function (udate) {
			var format = 'yyyy-MM-dd';
			if (arguments[1]) {
				format = arguments[1];
			}
			return $filter('date')(udate * 1000, format);
		};
	}]);

EwSiteApp.service("ajaxSearch", ['$http', '$q', function ($http, $q) {
		return({
			search: search
		});

		function search(url) {
			var cfg = {
				method: 'GET',
				url: url
			};
			if (arguments[1]) {
				cfg.params = arguments[1];
			}
			var request = $http(cfg);
			return(request.then(succesHandler, errorHandler));
		}
		;

		function succesHandler(response) {
			return response.data;
		}

		function errorHandler(response) {
			if (!angular.isObject(response.data) || !response.data.message) {
				return($q.reject("An unknown error occurred."));
			}
			return($q.reject(response.data.message));
		}
		;
	}]);

EwSiteApp.factory('SessionService', ['$timeout', '$http', '$window', '$uibModal', '$interval', function($timeout, $http, $window, $uibModal, $interval) {
		const SESSION_DURATION = sessionCfg.gc_maxlifetime * 1000;
		const MODAL_SHOW_BEFORE = sessionCfg.timer * 1000;
		let warningTimer, logoutTimer;

		function startTimers() {
			warningTimer = $timeout(() => {
				showWarningModal(sessionCfg.timer);
			}, SESSION_DURATION - MODAL_SHOW_BEFORE);

			logoutTimer = $timeout(() => {
			  // Session expired silently (no auto-action)
			}, SESSION_DURATION);
		}

		function resetTimers() {
			$timeout.cancel(warningTimer);
			$timeout.cancel(logoutTimer);
			startTimers();
		}

		function showWarningModal(secondsLeft) {
			const modalInstance = $uibModal.open({
				backdrop: 'static',
				keyboard: false,
				windowClass: 'session-modal-sm xsrf-modal',
				templateUrl: 'secure/session_expire_modal.html',
				controller: ['$scope', '$interval', '$sce', '$http', '$window', '$uibModalInstance', function ($scope, $interval, $sce, $http, $window, $uibModalInstance) {
						$scope.countdown = secondsLeft;
						$scope.countdown_expired = false;

						// wrap the seconds in a span and mark safe for ng-bind-html
						function renderCountdown(secs) {
							return $sce.trustAsHtml(
									`<span class="countdown-seconds">${secs}</span> sekundžių`
									);
						}

						// initial render
						$scope.formattedCountdown = renderCountdown($scope.countdown);

						const countdownTimer = $interval(() => {
							$scope.countdown--;
							$scope.formattedCountdown = renderCountdown($scope.countdown);

							if ($scope.countdown <= 0) {
								$scope.countdown_expired = true;
								$interval.cancel(countdownTimer);
							}
						}, 1000);

						$scope.stay = () => {
							$http.get(sessionCfg.dataUrl).then(() => {
								$interval.cancel(countdownTimer);
								resetTimers();
								$uibModalInstance.close();
							});
						};

						$scope.logout = () => {
							$interval.cancel(countdownTimer);
							$uibModalInstance.close();
							$window.location.reload();
						};

						$scope.$on('$destroy', () => $interval.cancel(countdownTimer));
					}]
			});
		}


		function logout() {
			$window.location.reload();
		}

		return {
			init: function () {
				startTimers();

			},
			stop: function () {
				$timeout.cancel(warningTimer);
				$timeout.cancel(logoutTimer);
			}
		};
}]);


EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
    // Utility function to get a cookie value
    function getJsCookieValue(a) {
		let b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
		return b ? b.pop() : '';
	}

	flowFactoryProvider.defaults = {
		target: '',
		permanentErrors: [202, 404, 500, 501],
		maxChunkRetries: 1,
		chunkRetryInterval: 5000,
		simultaneousUploads: 1,
        singleFile: false,
		chunkSize: 2 * 1024 * 1024,
		forceChunkSize: true,
		testChunks: false
	};

    // Workaround for issue https://github.com/flowjs/ng-flow/issues/92
	flowFactoryProvider.factory = function (opts) {
		let Flow = require('@flowjs/flow.js/dist/flow.js');
		return new Flow(opts);
	};

	/**
	 * ESOEW4-1545: XSRF antraste sudaroma kiekvienos siunciamos dalies metu.
	 *
	 * Anksciau tokenas buvo nuskaitomas viena karta, moduli konfiguruojant, ir
	 * uzsaldomas puslapio gyvavimo laikui. Ilgai pildant forma serveris tokena
	 * pakeicia (pasibaigusi sesija, atnaujintas sausainelis), todel ikelimas
	 * buvo blokuojamas ir jokiu budu nebeatsigaudavo iki puslapio perkrovimo.
	 * Flow leidzia headers paduoti funkcija - ji kvieciama pries kiekviena xhr.
	 *
	 * X-Requested-With reikalinga tam, kad blokuota uzklausa grazintu JSON
	 * (zr. secureModule::isJsonRequest), o ne HTML puslapi, kurio nepavyksta
	 * perskaityti.
	 */
	flowFactoryProvider.defaults.headers = function () {
		var headers = {'X-Requested-With': 'XMLHttpRequest'};
		if (typeof (secure_xsrf_name) != 'undefined') {
			var xsrf_token = getJsCookieValue(secure_xsrf_name);
			if (xsrf_token !== '') {
				headers['X-' + secure_xsrf_name] = xsrf_token;
			}
		}
		return headers;
	};

	// ESOEW4-1545: netiketa (ne JSON) atsakyma paverciam atpazistama klaida.
	// Anksciau JSON.parse isimtis nutraukdavo ivykiu grandine: failas likdavo
	// sarase kaip prisegtas, bet nebuvo nei uzskaitytas, nei parodyta klaida.
	flowFactoryProvider.on('fileSuccess', function (file, response) {
		try {
			file.response = angular.fromJson(response);
		} catch (e) {
			file.response = {success: false};
		}
	});
}]);


EwSiteApp.service('localStorageService', function () {
	var storageKey;
	var defaultData = {};
	var data;

	function init(name, default_data) {
		storageKey = name;
		defaultData = angular.copy(default_data || {});
		readData();
	}
	function getEmptyDataSet() {
		return angular.copy(defaultData);
	}

	function readData() {
		var d = localStorage.getItem(storageKey);
		data = d ? angular.merge({}, getEmptyDataSet(), angular.fromJson(d)): getEmptyDataSet();
	}

	function getData() {
		return data;
	}

	function storeData() {
		try {
			localStorage.setItem(storageKey, angular.toJson(data || getEmptyDataSet()));
		} catch (e) {
			console && console.warn && console.warn('localStorage write failed:', e);
		}
	}

	function setData(newdata) {
		data = angular.merge({}, getEmptyDataSet(), newdata || {});
		storeData();
	}

	function setParam(paramName, value) {
		data[paramName] = value;
		storeData();
	}
	
	function getParam(paramName) {
		return (typeof data[paramName] === 'undefined') ? null : data[paramName];
	}

	function clear() {
		if (storageKey)
			localStorage.removeItem(storageKey);
		data = getEmptyDataSet();
	}

	return {init, setParam, getParam, getData, setData, clear};
});

export {EwSiteApp};
